/**
 * @file オプションモーダル
 */
'use strict';
// utility class

/**
 * @classname OptionModalView
 * @classdesc オプションモーダル
 */
export default class OptionModalView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {object} controller - コントローラー
	 */
	constructor($e, controller) {
		console.log('OptionModalView.constructor');
		this._$e = $e;
		this._controller = controller;
		this._productId = $e.attr('data-product-id');
		this._skuId = $e.attr('data-sku-id');
		this._skuName = $e.attr('data-sku-name');
		this._productName = $e.attr('data-product-name');
		this._$recieveDate = $('#recieveDate');
		this._$recieveTime = $('#recieveTime');
		this._$note = $('#note');
		this._price = parseInt($e.attr('data-price'));
		this._image = $e.attr('data-image');
		this._$modal = $('#optionModal');
		this._$productId = $('#optionProductId');
		this._$skuId = $('#optionSkuId');
		$e.on('click', () => {this.onClick();});
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof OptionModalView
	 * @return {undefined}
	 */
	onClick() {
		console.log('OptionModalView.onClick');
		this._$modal.attr('data-product-id', this._productId);
		this._$modal.attr('data-sku-id', this._skuId);
		this._$modal.attr('data-sku-name', this._skuName);
		this._$modal.attr('data-image', this._image).find('.block-image-box img').attr('src', this._image);
		this._$modal.attr('data-product-name', this._productName).find('.text-product-name').html(this._productName);
		this._$modal.attr('data-price', this._price).find('.text-cart-price strong').html(`¥${this._price.toLocaleString()}`);
		this._$productId.val(this._productId);
		this._$skuId.val(this._skuId);
		$('#optionRecieveDate').val(this._$recieveDate.val());
		$('#optionRecieveTime').val(this._$recieveTime.val());
		$('#optionNote').val(this._$note.val());
		this._$modal.modal('show');
	};
}
